export enum Payer {
  COMPANY = 'Bedriftsbetalt',
  STB = 'Storebrand Livsforsikring As',
}

export enum SystemName {
  USB = 'USB',
  COP = 'COP',
  SPL = 'SPL',
  ALI = 'ALI',
  ABA = 'ABA',
  NAV = 'NAV',
  IPA = 'IPA',
  CMS = 'CMS',
  SKD = 'SKD', // F2100
  BNK = 'BNK',
  VPS = 'VPS',
  TCM = 'TCM',
}
